import { CashTransactionTypeEnum } from 'api-hooks/transactions/cash-transaction';
import { Input } from 'components/elements';
import { HalfContainer } from 'components/styles';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import TransactionCategorySelectInput from 'legacy-modules/master/transaction-category/components/select-input';
import { SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function TransactionSection() {
  const { t } = useTranslation();
  return (
    <>
      <HalfContainer>
        <TransactionCategorySelectInput name="transactionCategoryId" required />
      </HalfContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="select"
            name="type"
            label={t('common:type')}
            options={[
              {
                id: CashTransactionTypeEnum.debit,
                label: t(`common:${CashTransactionTypeEnum.debit}`),
              },
              {
                id: CashTransactionTypeEnum.credit,
                label: t(`common:${CashTransactionTypeEnum.credit}`),
              },
            ]}
            placeholder={t('common:type')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <CashAccountSelectInput name="cashAccountId" required />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="amount"
            label={t('common:amount')}
            placeholder={t('common:amount')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text-area"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
    </>
  );
}
